import type { ViewModelEntity } from '@view-model/domain/view-model';
import { NewViewModelTagIcon } from './NewViewModelTagIcon';
import { ViewModelTagList } from './ViewModelTagList';
import { NewViewModelTagSearchWindow } from './NewViewModelTagSearchWindow';
import { usePopupRef } from '@framework/hooks';
import { useState } from 'react';
import { useCurrentUserId } from '@framework/auth';

type Props = {
  viewModel: ViewModelEntity;
};

export const ViewModelTagController: React.FC<Props> = ({ viewModel }: Props) => {
  const { isOpen, popupRef, handleOpen, handleClose: handleCloseSearchWindow } = usePopupRef<HTMLDivElement>(false);

  const [addNewTagDisabled, setAddNewTagDisabled] = useState<boolean>(false);

  const currentUserId = useCurrentUserId();
  if (currentUserId === null) {
    return null;
  }

  return (
    <div className="flex gap-3">
      <NewViewModelTagIcon onAddNewTag={handleOpen} disabled={addNewTagDisabled} />
      <NewViewModelTagSearchWindow
        isOpen={isOpen}
        popupRef={popupRef}
        currentUserId={currentUserId}
        viewModel={viewModel}
        onCloseSearchWindow={handleCloseSearchWindow}
      />
      <ViewModelTagList viewModel={viewModel} setAddNewTagDisabled={setAddNewTagDisabled} />
    </div>
  );
};
